import { Subject } from 'rxjs';
import { IModuleEvent } from '../types/IModuleEvent';

export const eventEmitter = new Subject<IModuleEvent>();
export default eventEmitter;
